/**
 * @file 反馈页新增的vue数据store
 */
import * as Types from '../mutation-types';
import {getPlatInfo, post, captureException} from '@baidu/map-fe-utils';
import Const from '../../constant/Constant';
import {makeSign} from '../../helper/crypto';

import request from '../../request';
import {getExtralConfig} from '@/pages/pano-feed/constant/RequestConfig.js';

const state = () => ({
    config: {},
    feedPopup: [], // 反馈弹框的问题列表
    feedContent: [], // 反馈页的问题列表
    musicList: [], // 音乐列表
    attentionInfo: [],
    titleConf: {},
    searchTag: '',
    navConf: null
});

const mutations = {
    // 音乐+反馈弹框问题+反馈页按钮问题
    [Types.MAKE_MUSIC_FEED_DATA](state, data) {
        const {music_list = [], feed_popup = [], feed_content = []} = data;
        state.musicList = music_list;
        state.feedPopup = feed_popup;
        state.feedContent = feed_content;

        state.config = data;
    },
    [Types.SET_ATTENTION_INFO](state, data) {
        state.attentionInfo = data;
    },
    setTitleConf(state, data) {
        state.titleConf = data;
    },
    setSearchTag(state, data) {
        state.searchTag = data;
    },
    setNavConf(state, data) {
        state.navConf = data;
    }
};

const getters = {
    curTime: state => state.config.time || (Date.now() / 1000),
    remindDialogInfo: state => state.config.thematic || null,
    nextBtnConfig: state => state.config.next_btn_config || {}
};
const actions = {
    // 提交反馈post
    postFeedBack({state, rootState}, params) {
        let cuid = decodeURIComponent(rootState.urlParams.cuid);
        const fetchParams = Object.assign({}, params, {
            qt: 'submitfeedback',
            from: 'h5map',
            cuid,
            source: getPlatInfo().isNative ? 'in_app' : 'out_app'
        });

        const url = Const.dataUrl.submitfeedback;
        const slot = 'xYhGb&l&*t8e';
        fetchParams.pano_sign = makeSign(fetchParams, slot);
        return post(url, fetchParams).then(res => {
            if (res && res.data && res.data.result && res.data.result.error === 0) {
                return true;
            }
            // 反馈超过次数
            if (res && res.data && res.data.result && res.data.result.error === 11002) {
                return null;
            }
            throw res.data.result.msg || '网络繁忙，请稍后再试';
        }).catch(e => {
            console.error(e);
            const myErrorMessage = {
                message: `submitfeedback data error:${JSON.stringify(e)}`
            };
            captureException('submitfeedbackError', JSON.stringify(myErrorMessage));
            throw e;
        });
    },
    // 获取音乐列表以及反馈数据
    getMusicAndFeedData({rootState, commit}) {
        let cuid = decodeURIComponent(rootState.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        const fetchParams = {
            qt: 'getfeedbackandmusic',
            from: 'h5map',
            cuid
        };
        return request(getExtralConfig, fetchParams).then(res => {
            if (res && res.result.error === 0 && res.content) {
                commit(Types.MAKE_MUSIC_FEED_DATA, res.content);
                commit('setTitleConf', res.content.feed_title_style || {});
                commit('setSearchTag', res.content.search_tag || '');
                commit('setNavConf', res.content.feed_config && (res.content.feed_config.bottom_conf || null));
                if (res.content.attention_tip) {
                    commit(Types.SET_ATTENTION_INFO, res.content.attention_tip);
                }
            }
        }).catch(e => {
            console.error(e);
            const myErrorMessage = {
                message: `getfeedextral data error:${JSON.stringify(e)}`
            };
            captureException('getfeedextralError', JSON.stringify(myErrorMessage));
            throw e;
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};